import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_sentryserver_508a4a1f from 'nuxt_plugin_sentryserver_508a4a1f'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2a5e4ed2 from 'nuxt_plugin_sentryclient_2a5e4ed2'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_appplugin_03ec1e92 from 'nuxt_plugin_appplugin_03ec1e92'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_2eec5f78 from 'nuxt_plugin_configplugin_2eec5f78'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_vue2editor_5cdd2063 from 'nuxt_plugin_vue2editor_5cdd2063'; // Source: ./vue2-editor.js (mode: 'client')
import nuxt_plugin_apollomodule_7a5b5627 from 'nuxt_plugin_apollomodule_7a5b5627'; // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_86896f7a from 'nuxt_plugin_nuxtvuexroutersync_86896f7a'; // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_deviceplugin_72b021e6 from 'nuxt_plugin_deviceplugin_72b021e6'; // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5988c1fa from 'nuxt_plugin_cookieuniversalnuxt_5988c1fa'; // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_56aa155b from 'nuxt_plugin_axios_56aa155b'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_a0e46050 from 'nuxt_plugin_capiplugin_a0e46050'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_23e56bd1 from 'nuxt_plugin_errorpluginserver_23e56bd1'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_image_41b11256 from 'nuxt_plugin_image_41b11256'; // Source: ./image.js (mode: 'all')
import nuxt_plugin_fontLoader_c0a4d3ca from 'nuxt_plugin_fontLoader_c0a4d3ca'; // Source: ./fontLoader.js (mode: 'client')
import nuxt_plugin_pluginserver_00c095fe from 'nuxt_plugin_pluginserver_00c095fe'; // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_cc33790e from 'nuxt_plugin_pluginclient_cc33790e'; // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56'; // Source: ../plugins/sentry (mode: 'all')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e'; // Source: ../plugins/polyfills (mode: 'all')
import nuxt_plugin_extendnuxtapp_5bc53118 from 'nuxt_plugin_extendnuxtapp_5bc53118'; // Source: ../plugins/extend-nuxt-app (mode: 'all')
import nuxt_plugin_modal_4f7cf3d0 from 'nuxt_plugin_modal_4f7cf3d0'; // Source: ../plugins/modal (mode: 'all')
import nuxt_plugin_portal_4532993c from 'nuxt_plugin_portal_4532993c'; // Source: ../plugins/portal (mode: 'all')
import nuxt_plugin_notice_4c047c64 from 'nuxt_plugin_notice_4c047c64'; // Source: ../plugins/notice (mode: 'all')
import nuxt_plugin_axios_bbd72732 from 'nuxt_plugin_axios_bbd72732'; // Source: ../plugins/axios/axios (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076'; // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_breakpoint_4655f928 from 'nuxt_plugin_breakpoint_4655f928'; // Source: ../plugins/breakpoint (mode: 'all')
import nuxt_plugin_transitions_4f4e7c88 from 'nuxt_plugin_transitions_4f4e7c88'; // Source: ../plugins/transitions (mode: 'all')
import nuxt_plugin_bravadotooltip_d05518d6 from 'nuxt_plugin_bravadotooltip_d05518d6'; // Source: ../plugins/bravado_tooltip (mode: 'all')
import nuxt_plugin_globalcomponents_68527f08 from 'nuxt_plugin_globalcomponents_68527f08'; // Source: ../plugins/global_components (mode: 'all')
import nuxt_plugin_signuppopupwithdelay_2fd6efd5 from 'nuxt_plugin_signuppopupwithdelay_2fd6efd5'; // Source: ../plugins/sign-up-popup-with-delay (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249'; // Source: ../plugins/gtag (mode: 'client')
import nuxt_plugin_3rdparty_3ee029b2 from 'nuxt_plugin_3rdparty_3ee029b2'; // Source: ../plugins/3rd-party (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0'; // Source: ../plugins/analytics (mode: 'client')
import nuxt_plugin_analyticslogger_f98c56bc from 'nuxt_plugin_analyticslogger_f98c56bc'; // Source: ../plugins/analytics-logger (mode: 'client')
import nuxt_plugin_scrolllog_e3576a70 from 'nuxt_plugin_scrolllog_e3576a70'; // Source: ../plugins/scroll_log (mode: 'client')
import nuxt_plugin_logpageview_b76c4138 from 'nuxt_plugin_logpageview_b76c4138'; // Source: ../plugins/log_page_view (mode: 'client')
import nuxt_plugin_tooltip_ba49f866 from 'nuxt_plugin_tooltip_ba49f866'; // Source: ../plugins/tooltip (mode: 'client')
import nuxt_plugin_vue2touchevents_0aa7791c from 'nuxt_plugin_vue2touchevents_0aa7791c'; // Source: ../plugins/vue2-touch-events (mode: 'client')
import nuxt_plugin_viewport_3a6b3e1c from 'nuxt_plugin_viewport_3a6b3e1c'; // Source: ../plugins/viewport (mode: 'client')
import nuxt_plugin_logtransitionintowrmember_f3350dd0 from 'nuxt_plugin_logtransitionintowrmember_f3350dd0'; // Source: ../plugins/log-transition-into-wr-member (mode: 'client')
import nuxt_plugin_vclickoutside_661f0b13 from 'nuxt_plugin_vclickoutside_661f0b13'; // Source: ../plugins/v-click-outside (mode: 'client')
import nuxt_plugin_ab_5d03bbd2 from 'nuxt_plugin_ab_5d03bbd2'; // Source: ../plugins/ab (mode: 'all')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a'; // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_globalconstants_33fbe1ae from 'nuxt_plugin_globalconstants_33fbe1ae'; // Source: ../plugins/global_constants (mode: 'all')
import nuxt_plugin_401redirect_7693861c from 'nuxt_plugin_401redirect_7693861c'; // Source: ../plugins/401_redirect (mode: 'all')
import nuxt_plugin_cypress_30b22557 from 'nuxt_plugin_cypress_30b22557'; // Source: ../plugins/cypress (mode: 'all')
import nuxt_plugin_cancelablenotice_628ef426 from 'nuxt_plugin_cancelablenotice_628ef426'; // Source: ../plugins/cancelable_notice (mode: 'all')
import nuxt_plugin_confirm_1f801a8a from 'nuxt_plugin_confirm_1f801a8a'; // Source: ../plugins/confirm (mode: 'all')
import nuxt_plugin_pages_33d4e3e4 from 'nuxt_plugin_pages_33d4e3e4'; // Source: ../plugins/pages (mode: 'all')
import nuxt_plugin_calendly_2f137be0 from 'nuxt_plugin_calendly_2f137be0'; // Source: ../plugins/calendly (mode: 'client')
import nuxt_plugin_bravadonav_55292b27 from 'nuxt_plugin_bravadonav_55292b27'; // Source: ../plugins/bravado-nav (mode: 'all')
import nuxt_plugin_auth_03780716 from 'nuxt_plugin_auth_03780716'; // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e'; // Source: ../plugins/auth (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
          store.registerModule = registerModule;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": "Join Bravado - The World’s Largest Sales Network",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "description",
                "hid": "description",
                "content": "Bravado is a community for the world’s top sales professionals. Join the War Room today to become the best with the best"
              }, {
                "name": "viewport",
                "hid": "viewport",
                "content": "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"
              }, {
                "name": "google-site-verification",
                "hid": "google",
                "content": "51yg69067XmlVMb-HSJTa2SmLt0G71R7keH9-sV5A_4"
              }, {
                "hid": "fb",
                "property": "fb:app_id",
                "content": "526703391488301"
              }, {
                "hid": "og:image",
                "property": "og:image",
                "content": "https://bravado-static.s3-us-west-1.amazonaws.com/og_images/default_seo.png"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico"
              }, {
                "hid": "google-font-prefetch",
                "rel": "dns-prefetch",
                "href": "https://fonts.gstatic.com/"
              }, {
                "hid": "google-font-preconnect",
                "rel": "preconnect",
                "href": "https://fonts.gstatic.com/",
                "crossorigin": ""
              }, {
                "hid": "google-font-preload",
                "rel": "preload",
                "as": "style",
                "href": "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap"
              }, {
                "hid": "custom-font-prefetch",
                "rel": "dns-prefetch",
                "href": "https://use.typekit.net/"
              }, {
                "hid": "custom-font-preconnect",
                "rel": "preconnect",
                "href": "https://use.typekit.net/",
                "crossorigin": ""
              }, {
                "hid": "custom-font-preload",
                "rel": "preload",
                "as": "style",
                "href": "https://api.fontshare.com/v2/css?f%5B%5D=clash-display@500&display=swap"
              }],
              "htmlAttrs": {
                "lang": "en"
              },
              "script": [{
                "hid": "gdpr",
                "src": "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
                "async": true,
                "data-language": "en",
                "data-domain-script": "161d3426-168b-4768-afd0-b0a779373e27"
              }],
              "bodyAttrs": {
                "class": "body"
              },
              "style": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 14;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 14:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(process.server && typeof nuxt_plugin_sentryserver_508a4a1f === 'function')) {
            _context2.next = 20;
            break;
          }
          _context2.next = 20;
          return nuxt_plugin_sentryserver_508a4a1f(app.context, inject);
        case 20:
          if (!(process.client && typeof nuxt_plugin_sentryclient_2a5e4ed2 === 'function')) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return nuxt_plugin_sentryclient_2a5e4ed2(app.context, inject);
        case 23:
          if (!(typeof nuxt_plugin_appplugin_03ec1e92 === 'function')) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return nuxt_plugin_appplugin_03ec1e92(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_configplugin_2eec5f78 === 'function')) {
            _context2.next = 29;
            break;
          }
          _context2.next = 29;
          return nuxt_plugin_configplugin_2eec5f78(app.context, inject);
        case 29:
          if (!(process.client && typeof nuxt_plugin_vue2editor_5cdd2063 === 'function')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 32;
          return nuxt_plugin_vue2editor_5cdd2063(app.context, inject);
        case 32:
          if (!(typeof nuxt_plugin_apollomodule_7a5b5627 === 'function')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 35;
          return nuxt_plugin_apollomodule_7a5b5627(app.context, inject);
        case 35:
          if (!(typeof nuxt_plugin_nuxtvuexroutersync_86896f7a === 'function')) {
            _context2.next = 38;
            break;
          }
          _context2.next = 38;
          return nuxt_plugin_nuxtvuexroutersync_86896f7a(app.context, inject);
        case 38:
          if (!(typeof nuxt_plugin_deviceplugin_72b021e6 === 'function')) {
            _context2.next = 41;
            break;
          }
          _context2.next = 41;
          return nuxt_plugin_deviceplugin_72b021e6(app.context, inject);
        case 41:
          if (!(typeof nuxt_plugin_cookieuniversalnuxt_5988c1fa === 'function')) {
            _context2.next = 44;
            break;
          }
          _context2.next = 44;
          return nuxt_plugin_cookieuniversalnuxt_5988c1fa(app.context, inject);
        case 44:
          if (!(typeof nuxt_plugin_axios_56aa155b === 'function')) {
            _context2.next = 47;
            break;
          }
          _context2.next = 47;
          return nuxt_plugin_axios_56aa155b(app.context, inject);
        case 47:
          if (!(typeof nuxt_plugin_capiplugin_a0e46050 === 'function')) {
            _context2.next = 50;
            break;
          }
          _context2.next = 50;
          return nuxt_plugin_capiplugin_a0e46050(app.context, inject);
        case 50:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_23e56bd1 === 'function')) {
            _context2.next = 53;
            break;
          }
          _context2.next = 53;
          return nuxt_plugin_errorpluginserver_23e56bd1(app.context, inject);
        case 53:
          if (!(typeof nuxt_plugin_image_41b11256 === 'function')) {
            _context2.next = 56;
            break;
          }
          _context2.next = 56;
          return nuxt_plugin_image_41b11256(app.context, inject);
        case 56:
          if (!(process.client && typeof nuxt_plugin_fontLoader_c0a4d3ca === 'function')) {
            _context2.next = 59;
            break;
          }
          _context2.next = 59;
          return nuxt_plugin_fontLoader_c0a4d3ca(app.context, inject);
        case 59:
          if (!(process.server && typeof nuxt_plugin_pluginserver_00c095fe === 'function')) {
            _context2.next = 62;
            break;
          }
          _context2.next = 62;
          return nuxt_plugin_pluginserver_00c095fe(app.context, inject);
        case 62:
          if (!(process.client && typeof nuxt_plugin_pluginclient_cc33790e === 'function')) {
            _context2.next = 65;
            break;
          }
          _context2.next = 65;
          return nuxt_plugin_pluginclient_cc33790e(app.context, inject);
        case 65:
          if (!(typeof nuxt_plugin_sentry_3c12fa56 === 'function')) {
            _context2.next = 68;
            break;
          }
          _context2.next = 68;
          return nuxt_plugin_sentry_3c12fa56(app.context, inject);
        case 68:
          if (!(typeof nuxt_plugin_polyfills_7dce8c4e === 'function')) {
            _context2.next = 71;
            break;
          }
          _context2.next = 71;
          return nuxt_plugin_polyfills_7dce8c4e(app.context, inject);
        case 71:
          if (!(typeof nuxt_plugin_extendnuxtapp_5bc53118 === 'function')) {
            _context2.next = 74;
            break;
          }
          _context2.next = 74;
          return nuxt_plugin_extendnuxtapp_5bc53118(app.context, inject);
        case 74:
          if (!(typeof nuxt_plugin_modal_4f7cf3d0 === 'function')) {
            _context2.next = 77;
            break;
          }
          _context2.next = 77;
          return nuxt_plugin_modal_4f7cf3d0(app.context, inject);
        case 77:
          if (!(typeof nuxt_plugin_portal_4532993c === 'function')) {
            _context2.next = 80;
            break;
          }
          _context2.next = 80;
          return nuxt_plugin_portal_4532993c(app.context, inject);
        case 80:
          if (!(typeof nuxt_plugin_notice_4c047c64 === 'function')) {
            _context2.next = 83;
            break;
          }
          _context2.next = 83;
          return nuxt_plugin_notice_4c047c64(app.context, inject);
        case 83:
          if (!(typeof nuxt_plugin_axios_bbd72732 === 'function')) {
            _context2.next = 86;
            break;
          }
          _context2.next = 86;
          return nuxt_plugin_axios_bbd72732(app.context, inject);
        case 86:
          if (!(typeof nuxt_plugin_filters_98405076 === 'function')) {
            _context2.next = 89;
            break;
          }
          _context2.next = 89;
          return nuxt_plugin_filters_98405076(app.context, inject);
        case 89:
          if (!(typeof nuxt_plugin_breakpoint_4655f928 === 'function')) {
            _context2.next = 92;
            break;
          }
          _context2.next = 92;
          return nuxt_plugin_breakpoint_4655f928(app.context, inject);
        case 92:
          if (!(typeof nuxt_plugin_transitions_4f4e7c88 === 'function')) {
            _context2.next = 95;
            break;
          }
          _context2.next = 95;
          return nuxt_plugin_transitions_4f4e7c88(app.context, inject);
        case 95:
          if (!(typeof nuxt_plugin_bravadotooltip_d05518d6 === 'function')) {
            _context2.next = 98;
            break;
          }
          _context2.next = 98;
          return nuxt_plugin_bravadotooltip_d05518d6(app.context, inject);
        case 98:
          if (!(typeof nuxt_plugin_globalcomponents_68527f08 === 'function')) {
            _context2.next = 101;
            break;
          }
          _context2.next = 101;
          return nuxt_plugin_globalcomponents_68527f08(app.context, inject);
        case 101:
          if (!(process.client && typeof nuxt_plugin_signuppopupwithdelay_2fd6efd5 === 'function')) {
            _context2.next = 104;
            break;
          }
          _context2.next = 104;
          return nuxt_plugin_signuppopupwithdelay_2fd6efd5(app.context, inject);
        case 104:
          if (!(process.client && typeof nuxt_plugin_gtag_6a810249 === 'function')) {
            _context2.next = 107;
            break;
          }
          _context2.next = 107;
          return nuxt_plugin_gtag_6a810249(app.context, inject);
        case 107:
          if (!(process.client && typeof nuxt_plugin_3rdparty_3ee029b2 === 'function')) {
            _context2.next = 110;
            break;
          }
          _context2.next = 110;
          return nuxt_plugin_3rdparty_3ee029b2(app.context, inject);
        case 110:
          if (!(process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function')) {
            _context2.next = 113;
            break;
          }
          _context2.next = 113;
          return nuxt_plugin_analytics_0ae804d0(app.context, inject);
        case 113:
          if (!(process.client && typeof nuxt_plugin_analyticslogger_f98c56bc === 'function')) {
            _context2.next = 116;
            break;
          }
          _context2.next = 116;
          return nuxt_plugin_analyticslogger_f98c56bc(app.context, inject);
        case 116:
          if (!(process.client && typeof nuxt_plugin_scrolllog_e3576a70 === 'function')) {
            _context2.next = 119;
            break;
          }
          _context2.next = 119;
          return nuxt_plugin_scrolllog_e3576a70(app.context, inject);
        case 119:
          if (!(process.client && typeof nuxt_plugin_logpageview_b76c4138 === 'function')) {
            _context2.next = 122;
            break;
          }
          _context2.next = 122;
          return nuxt_plugin_logpageview_b76c4138(app.context, inject);
        case 122:
          if (!(process.client && typeof nuxt_plugin_tooltip_ba49f866 === 'function')) {
            _context2.next = 125;
            break;
          }
          _context2.next = 125;
          return nuxt_plugin_tooltip_ba49f866(app.context, inject);
        case 125:
          if (!(process.client && typeof nuxt_plugin_vue2touchevents_0aa7791c === 'function')) {
            _context2.next = 128;
            break;
          }
          _context2.next = 128;
          return nuxt_plugin_vue2touchevents_0aa7791c(app.context, inject);
        case 128:
          if (!(process.client && typeof nuxt_plugin_viewport_3a6b3e1c === 'function')) {
            _context2.next = 131;
            break;
          }
          _context2.next = 131;
          return nuxt_plugin_viewport_3a6b3e1c(app.context, inject);
        case 131:
          if (!(process.client && typeof nuxt_plugin_logtransitionintowrmember_f3350dd0 === 'function')) {
            _context2.next = 134;
            break;
          }
          _context2.next = 134;
          return nuxt_plugin_logtransitionintowrmember_f3350dd0(app.context, inject);
        case 134:
          if (!(process.client && typeof nuxt_plugin_vclickoutside_661f0b13 === 'function')) {
            _context2.next = 137;
            break;
          }
          _context2.next = 137;
          return nuxt_plugin_vclickoutside_661f0b13(app.context, inject);
        case 137:
          if (!(typeof nuxt_plugin_ab_5d03bbd2 === 'function')) {
            _context2.next = 140;
            break;
          }
          _context2.next = 140;
          return nuxt_plugin_ab_5d03bbd2(app.context, inject);
        case 140:
          if (!(typeof nuxt_plugin_utils_3336a20a === 'function')) {
            _context2.next = 143;
            break;
          }
          _context2.next = 143;
          return nuxt_plugin_utils_3336a20a(app.context, inject);
        case 143:
          if (!(typeof nuxt_plugin_globalconstants_33fbe1ae === 'function')) {
            _context2.next = 146;
            break;
          }
          _context2.next = 146;
          return nuxt_plugin_globalconstants_33fbe1ae(app.context, inject);
        case 146:
          if (!(typeof nuxt_plugin_401redirect_7693861c === 'function')) {
            _context2.next = 149;
            break;
          }
          _context2.next = 149;
          return nuxt_plugin_401redirect_7693861c(app.context, inject);
        case 149:
          if (!(typeof nuxt_plugin_cypress_30b22557 === 'function')) {
            _context2.next = 152;
            break;
          }
          _context2.next = 152;
          return nuxt_plugin_cypress_30b22557(app.context, inject);
        case 152:
          if (!(typeof nuxt_plugin_cancelablenotice_628ef426 === 'function')) {
            _context2.next = 155;
            break;
          }
          _context2.next = 155;
          return nuxt_plugin_cancelablenotice_628ef426(app.context, inject);
        case 155:
          if (!(typeof nuxt_plugin_confirm_1f801a8a === 'function')) {
            _context2.next = 158;
            break;
          }
          _context2.next = 158;
          return nuxt_plugin_confirm_1f801a8a(app.context, inject);
        case 158:
          if (!(typeof nuxt_plugin_pages_33d4e3e4 === 'function')) {
            _context2.next = 161;
            break;
          }
          _context2.next = 161;
          return nuxt_plugin_pages_33d4e3e4(app.context, inject);
        case 161:
          if (!(process.client && typeof nuxt_plugin_calendly_2f137be0 === 'function')) {
            _context2.next = 164;
            break;
          }
          _context2.next = 164;
          return nuxt_plugin_calendly_2f137be0(app.context, inject);
        case 164:
          if (!(typeof nuxt_plugin_bravadonav_55292b27 === 'function')) {
            _context2.next = 167;
            break;
          }
          _context2.next = 167;
          return nuxt_plugin_bravadonav_55292b27(app.context, inject);
        case 167:
          if (!(typeof nuxt_plugin_auth_03780716 === 'function')) {
            _context2.next = 170;
            break;
          }
          _context2.next = 170;
          return nuxt_plugin_auth_03780716(app.context, inject);
        case 170:
          if (!(typeof nuxt_plugin_auth_6a7e4e1e === 'function')) {
            _context2.next = 173;
            break;
          }
          _context2.next = 173;
          return nuxt_plugin_auth_6a7e4e1e(app.context, inject);
        case 173:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 176;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 176:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 177:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };